import { createContext, useContext } from "react";

const AdminRoleContext = createContext({});

export const AdminRoleProvider = AdminRoleContext.Provider;

export const useAdminRole = () => useContext(AdminRoleContext);
